import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ValidatorParamsModel} from "@amlCore/models";
import {ValidatorService} from "@amlCore/services";
import {Injectable} from "@angular/core";
import {CustomValidator, CustomValidatorError} from "@amlCore/utils";
import {ClientTypeEnum, DossierAccessEnum} from "@amlCore/enums";
import {
  DictType,
  DocumentInfoType,
  MigrationCardInfoType,
  ResidenceDocInfoType,
  TypeOrg
} from "../../../models/dossier";


@Injectable()
export class DossierBaseModel {

  constructor(protected formBuilder: FormBuilder, protected validationSrv: ValidatorService) {
  }

  /**
   * Сведения об учредителях/участниках
   */
  getSvedAu(data?: any): FormGroup {
    return this.formBuilder.group({
      state: null,
      part: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 8
      })],
      clientInfo: this.getClientInfo(DossierAccessEnum.SVEDAU, data?.clientInfo),
      bfOwner: null,
      bfOther: null,
      $partId: null,
      $checkedFlk: null,
      dateFrom: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      dateEnd: null,
      stopPowers: 0
    });
  }

  /**
   * Сведения о выгодоприобретателе
   */
   getSvedVPR(data?: any): FormGroup {
    return this.formBuilder.group({
      clientInfo: this.getClientInfo(DossierAccessEnum.SVEDVPR, data),
      $partId: null,
      $checkedFlk: null,
      vprProfit: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      vprOther: [null, this.validationSrv.getValidation({
        max: 100
      })],
      reason: [null, this.validationSrv.getValidation({
        max: 250
      })],
      dateFrom: [null, this.validationSrv.getValidation({
        isReq: true
      })]
    });
  }

   /**
   * Сведения о бенефициарном владельце
   */
    getSvedBv(data?: any): FormGroup {
      return this.formBuilder.group({
        clientInfo: this.getClientInfo(DossierAccessEnum.SVEDBV, data),
        bfOwner: null,
        bfOther: null,
        reason: null,
        $partId: null,
        $checkedFlk: null,
        dateFrom: [null, this.validationSrv.getValidation({
          isReq: true
        })],
        dateEnd: null,
        stopPowers: 0
      });
    }

  /**
   * Сведения об исполнительном органе управления
   */
  getSvedIUO(data?: any, param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      organUpr: this.getDictType({isReq: true}),
      organUprOther: [null, this.validationSrv.getValidation({
        max: 250,
        isReq: true
      })],
      base: [null, this.validationSrv.getValidation({
        max: 250
      })],
      dateFromV: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      dateEndV: null,
      type: this.getDictType({isReq: true}),
      part: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 8
      })],
      vidKolOU: this.getDictType({isReq: true}),
      otherOU: [null, this.validationSrv.getValidation({
        max: 250,
        isReq: true
      })],
      sostavIO: [],
      post: this.getDictType({isReq: true}),
      otherPost: [null, this.validationSrv.getValidation({
        max: 250,
        isReq: true
      })],
      dateResh: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      numberResh: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 100
      })],
      docName: [null, this.validationSrv.getValidation({
        max: 250,
        isReq: true
      })],
      clientInfo: this.getClientInfo(DossierAccessEnum.SVEDIOU, data),
      $partId: null,
      $checkedFlk: null
    }, this.validationSrv.getValidation(param));
  }

  getSostavIO(): FormGroup{
    return null;
  }

  /**
   * Сведения о представителях
   */
  getSvedPredst(data?: any): FormGroup {
    return this.formBuilder.group({
      clientInfo: this.getClientInfo(DossierAccessEnum.SVEDPREDST, data),
      authority: this.getAuthority(),
      $partId: null,
      $checkedFlk: null,
    });
  }

  /**
   * Сведения о лице
   */
  getClientInfo(typePage: DossierAccessEnum, data?: any): FormGroup {
    return this.formBuilder.group({
      clientType: [ClientTypeEnum.LEGAL_ENTITY, this.validationSrv.getValidation({
        isReq: true
      } as ValidatorParamsModel)],
      clientTrue: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      filial:  [1, this.validationSrv.getValidation({
        isReq: true
      })],
      filialNum:  [null, this.validationSrv.getValidation({
        isFilialNum: true
      })],
      gkfh: null,
      rezidentRf: null,
      clientId: null,
      version: null,
      rezidentUsa: typePage === DossierAccessEnum.SVEDCLIENT ? false : null,
      rezidentFS: typePage === DossierAccessEnum.SVEDCLIENT ? false : null,
      nerezidentRF: typePage === DossierAccessEnum.SVEDCLIENT ? false : null,
      svedUL: this.getSvedULType(typePage),
      svedFL: this.getSvedFLType(typePage, data?.svedFL),
      svedIP: this.getSvedIPType(typePage, data?.svedIP),
      svedFLCP: this.getSvedFLCPType(typePage, data?.svedFLCP),
      svedInbUL: this.getSvedInbULType(typePage),
      svedKO: this.getSvedKOType(typePage),
      $partId: null,
      $checkedFlk: null
    });
  }

  /**
   * Цели установления деловых отношений
   */
  getSvedTarget(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      charractDo: this.getDictType({isReq: true}),
      svedOperW: null,
      svedOperM: null,
      svedOperQ: null,
      svedOperY: null,
      orderCountW: [null, this.validationSrv.getValidation({
        max: 20
      })],
      orderCountM: [null, this.validationSrv.getValidation({
        max: 20
      })],
      orderCountQ: [null, this.validationSrv.getValidation({
        max: 20
      })],
      orderCountY: [null, this.validationSrv.getValidation({
        max: 20
      })],
      svedCashW: null,
      svedCashM: null,
      svedCashQ: null,
      svedCashY: null,
      ved: false,
      svedDBO: false,
      services: null
    }, this.validationSrv.getValidation(param));
  }

  /**
   * Адрес
   */
  getAddressType(type: AddressModelType): FormGroup {
    let countryValue = null;
    if (type === 'req') {
      countryValue = {
        name: "РОССИЙСКАЯ ФЕДЕРАЦИЯ",
        code: "643"
      };
    }
    return this.formBuilder.group({
      country: [countryValue, this.validationSrv.getValidation({
        isReq: true
      })],
      postIndex: [null, this.validationSrv.getValidation({
        max: 30
      })],
      region: null,
      area: [null, this.validationSrv.getValidation({
        max: 250
      })],
      city: [null, this.validationSrv.getValidation({
        max: 250
      })],
      locality: [null, this.validationSrv.getValidation({
        max: 250
      })],
      street: [null, this.validationSrv.getValidation({
        max: 250
      })],
      house: [null, this.validationSrv.getValidation({
        max: 60
      })],
      building: [null, this.validationSrv.getValidation({
        max: 50
      })],
      apartment: [null, this.validationSrv.getValidation({
        max: 100
      })],
      box: [null, this.validationSrv.getValidation({
        max: 50
      })],
    }, {validators: addressTypeValidator});
  }

  /**
   * Данные о регистрации
   */
  getRegInfoType(typePage: DossierAccessEnum): FormGroup {
    const isReq = [
      DossierAccessEnum.SVEDCLIENT,
      DossierAccessEnum.SVEDIOU,
      DossierAccessEnum.SVEDPREDST
    ].includes(typePage);
    const regInfoValidator = new RegInfoValidator(this.validationSrv, isReq, typePage);
    return this.formBuilder.group({
      ogrn: [null, this.validationSrv.getValidation({
        max: 15,
        isOGRN: true,
        isReq: isReq
      })],
      dateReg: [null, this.validationSrv.getValidation({
        isReq: isReq
      })],
      dateRegIn:  [null, this.validationSrv.getValidation({
        isReq: isReq
      })],
      regNum: [null, this.validationSrv.getValidation({
        max: 50,
        isReq: isReq
      })],
      nameRegOrg: [null, this.validationSrv.getValidation({
        max: 250,
        min: 3
      })]
    }, {validator: regInfoValidator.validator.bind(regInfoValidator)});
  }

  /**
   * Сведения о физическом лице, занимающемся частной практикой
   */
  getRegInfoCPType(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      vid: this.getDictType({isReq: true}),
      otherVid: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 50
      })],
      nameOrg: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 250
      })],
      regNum: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 50
      })],
      dateReg: [null, this.validationSrv.getValidation({
        isReq: true,
        isDate: true,
      })],
      numCertificate: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 50
      })],
      innCRO: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 10,
        isINN: 'INN_10'
      })],
      ogrnCRO: [null, this.validationSrv.getValidation({
        isReq: true,
        isOGRN: true,
        max: 50
      })],
    }, this.validationSrv.getValidation(param));
  }

  /**
   * Показатель справочника
   */
  getDictType(param?: ValidatorParamsModel, data?: DictType) {
    return [data, this.validationSrv.getValidation(param)];
  }

  /**
   * Наименования организации
   */
  getOrgNameType(): FormGroup {
    return this.formBuilder.group({
      orgNameFullRu: [null, this.validationSrv.getValidation({
        max: 2000
      })],
      orgNameRu: [null, this.validationSrv.getValidation({
        max: 500
      })],
      orgNameFullIn: [null, this.validationSrv.getValidation({
        max: 2000
      })],
      orgNameIn: [null, this.validationSrv.getValidation({
        max: 2000
      })]
    }, {validator: orgNameTypeValidator});
  }

  /**
   * Сведения о юридическом лице
   */
  getSvedULType(typePage: DossierAccessEnum): FormGroup {
    return this.formBuilder.group(
      {
        orgName: this.getOrgNameType(),
        opf: this.getDictType({isReq: true}),
        // Валидация задается в компоненте (динамическая)
        inn: null,
        // Валидация задается в компоненте (динамическая)
        kpp: null,
        okpo: [null, this.validationSrv.getValidation({
          max: 8,
          min: 8,
          isOKPO: true
        })],
        oktmo: [null, this.validationSrv.getValidation({
          max: 11,
          min: 8,
          isOKTMO: true
        })],
        okfs: this.getDictType(),
        okved: this.getOkvedType('ul', typePage),
        regInfo: this.getRegInfoType(typePage),
        licenseInfo: this.getlicenseInfo(),
        addressInfo: this.getAddressInfo(),
        contactInfo: this.getContactType()
      });
  }

  /**
   * Сведения о кредитной организации
   */
  getSvedKOType(typePage: DossierAccessEnum, rezidentRf?: FormControl): FormGroup {
    return this.formBuilder.group(
      {
        orgName: this.getOrgNameType(),
        opf: this.getDictType({isReq: true}),
        opfn: [null, this.validationSrv.getValidation({
          isReq: true,
          min: 3,
          max: 100
        })],
        okfs: this.getDictType({isReq: true}),
        // Валидация задается в компоненте (динамическая)
        inn: null,
        taxtin: [null, this.validationSrv.getValidation({
          min: 9,
          max: 19
        })],
        // Валидация задается в компоненте (динамическая)
        kpp: null,
        bik: null,
        swift: null,
        okpo: [null, this.validationSrv.getValidation({
          max: 8,
          min: 8,
          isOKPO: true
        })],
        oktmo: [null, this.validationSrv.getValidation({
          max: 11,
          min: 8,
          isOKTMO: true
        })],
        okved: this.getOkvedType('ul', typePage),
        regInfo: this.getRegInfoType(typePage),
        licenseInfo: this.getlicenseInfo(),
        addressInfo: this.getAddressInfo(),
        contactInfo: this.getContactType()
      });
  }


  /**
   * Сведения о физическом лице
   */
  getSvedFLType(typePage: DossierAccessEnum, data?: any): FormGroup {
    return this.formBuilder.group({
      fio: this.getFIOType(),
      personalData: this.getPersonalDataType('fl'),
      documentInfo: this.fbArray(this.getDocumentInfoType, data?.documentInfo, typePage),
      addressInfo: this.getAddressInfo(),
      contactInfo: this.getContactType(),
      publicInfo: this.getPublicInfoType()
    }, this.validationSrv.getValidation({
      isReq: true
    }));

  }

  getAddressInfo(param?: ValidatorParamsModel) {
    return this.formBuilder.group({
      addressReg: this.getAddressType('req'),
      addressReal: this.getAddressType('real'),
      addressPost: this.getAddressType('post'),
      realAsReg: true,
      postAsReg: true,
    }, this.validationSrv.getValidation(param));
  }

  /**
   * Сведения об индивидуальном предпринимателе
   */
  getSvedIPType(typePage: DossierAccessEnum, data?: any): FormGroup {
    return this.formBuilder.group({
      fio: this.getFIOType(),
      personalData: this.getPersonalDataType('ip'),
      documentInfo: this.fbArray(this.getDocumentInfoType, data?.documentInfo, typePage),
      okved: this.getOkvedType('ip', typePage),
      regInfo: this.getRegInfoType(typePage),
      licenseInfo: this.getlicenseInfo(),
      addressInfo: this.getAddressInfo(),
      contactInfo: this.getContactType(),
      publicInfo: this.getPublicInfoType()
    });
  }

  /**
   * Сведения о физическом лице частная практика
   */
  getSvedFLCPType(typePage: DossierAccessEnum, data?: any): FormGroup {
    return this.formBuilder.group({
      fio: this.getFIOType(),
      personalData: this.getPersonalDataType('flcp'),
      documentInfo: this.fbArray(this.getDocumentInfoType, data?.documentInfo, typePage),
      okved: this.getOkvedType('flcp', typePage),
      regInfoCP: this.getRegInfoCPType(),
      addressInfo: this.getAddressInfo(),
      contactInfo: this.getContactType(),
      publicInfo: this.getPublicInfoType()
    });
  }

  /**
   * Сведения об ИНБОЮЛ
   */
  getSvedInbULType(typePage: DossierAccessEnum): FormGroup {
    return this.formBuilder.group({
      orgName: this.getOrgNameType(),
      opf: this.getDictType({isReq: true}),
      inn: null, // Валидация задается в компоненте (динамическая)
      kpp: null, // Валидация задается в компоненте (динамическая)
      okved: this.getOkvedType('inbul', typePage),
      regInfoInbUL: this.getRegInfoInbULType(),
      licenseInfo: this.getlicenseInfo(),
      addressInfo: this.getAddressInfo(),
      contactInfo: this.getContactType()
    });
  }

  /**
   * Сведения о праве осуществления деятельности, подлежащей лицензированию
   */
  getlicenseInfo(param?: ValidatorParamsModel) {
    return null;
  }

  /**
   * Данные о регистрации ИНБОЮЛ
   */
  getRegInfoInbULType(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      opf: this.getDictType({isReq: true}),
      iof: [null, this.validationSrv.getValidation({
        max: 250,
      })],
      regNum: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      nalogCod: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      dateReg: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      nameRegOrg: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 250
      })],
    }, this.validationSrv.getValidation(param));
  }

  /**
   * Контакты
   */
  getContactType(): FormGroup {
    return this.formBuilder.group({
      phoneInfo: [],
      emailInfo: [],
      website: [null, this.validationSrv.getValidation({
        max: 100
      })]
    });
  }

  /**
   * Сведения о праве осуществления деятельности, подлежащей лицензированию
   */
  getLicenseType(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      type: [null, this.validationSrv.getValidation({
        max: 2000,
        isReq: true,
        min: 3
      })],
      number: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 250
      })],
      dateVid: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      dateStart: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      unlimited: false,
      dateEnd: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      action: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 2000,
        min: 3
      })],
      row: null
    }, this.validationSrv.getValidation(param));
  }

  /**
   * Фамилия, имя, отчество
   */
  getFIOType(): FormGroup {
    return this.formBuilder.group({
      lastName: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 100
      })],
      firstName: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 100
      })],
      middleName: [null, this.validationSrv.getValidation({
        max: 100
      })],
      fio: [null, this.validationSrv.getValidation({
        max: 302
      })],
      gender: [null, this.validationSrv.getValidation({
        max: 1, minNumber: 1, maxNumber: 4
      })]
    });
  }

  /**
   * Личные данные
   */
  getPersonalDataType(typeOrg: TypeOrg): FormGroup {
    const innValidator: ValidatorParamsModel = {
      max: 12,
      min: 12,
      isINN: true
    };
    // Инн обязателен для ИП
    innValidator.isReq = typeOrg === 'ip';
    return this.formBuilder.group({
      inn: [null, this.validationSrv.getValidation(innValidator)],
      snils: [null, this.validationSrv.getValidation({
        max: 14,
        isSNILS: true
      })],
      policyOMC: [null, this.validationSrv.getValidation({
        max: 16,
        min: 16,
        isPolicyOMC: true
      })],
      country: [{
        name: "РОССИЙСКАЯ ФЕДЕРАЦИЯ",
        code: "643"
      }, this.validationSrv.getValidation({
        isReq: true
      })],
      birthDate: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      birthPlace: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 2000
      })],
      birthNS: [
        {
          code:"1",
          name: "Гражданин полностью дееспособен (в том числе если несовершеннолетний гражданин эмансипирован или вступил в брак)"
        },
        this.validationSrv.getValidation({
          isReq: true
        })
      ],
    });
  }

  /**
   * Сведения о документе, удостоверяющем личность
   */
  getDocumentInfoType(typePage: DossierAccessEnum, data?: DocumentInfoType): FormGroup {
    return this.formBuilder.group({
      row: [data?.row ?? 0],
      nationality: this.getDictType({isReq: true}, data?.nationality),
      docType: this.getDictType({isReq: true}, data?.docType),
      docOther: [data?.docOther, this.validationSrv.getValidation({
        isReq: true
      })],
      series: [data?.series, this.validationSrv.getValidation({
        isReq: true
      })],
      number: [data?.number, this.validationSrv.getValidation({
        isReq: true
      })],
      organ: [data?.organ, this.validationSrv.getValidation({
        isReq: true
      })],
      dateDoc: [data?.dateDoc, this.validationSrv.getValidation({
        isReq: true
      })],
      dateEnd: [data?.dateEnd, this.validationSrv.getValidation({
        isReq: true
      })],
      validDoc: [data?.validDoc ?? "1", this.validationSrv.getValidation({
        max: 1
      })],
      kodPodr: [data?.kodPodr, this.validationSrv.getValidation({
        isReq: true,
        max: 7
      })],
      migrationCardInfo: this.getMigrationCardInfoType(data?.migrationCardInfo),
      residenceDocInfo: this.getResidenceDocInfoType(typePage, data?.residenceDocInfo)
    }, {validators: [seriesDocumentInfoValidator, numberDocumentInfoValidator, migrationCardInfoValidator.bind(this,typePage)]});
  }

  /**
   * Виды экономической деятельности
   */
  getOkvedType(typeOrg: TypeOrg, typePage: DossierAccessEnum): FormGroup {
    const okvedValidator: OkvedValidator = new OkvedValidator(typeOrg, typePage);
    return this.formBuilder.group({
      okved: [],
      okved2: [],
      okvedAdd: [],
      okved2Add: []
    }, {validator:  okvedValidator.validator.bind(okvedValidator)});
  }

  /**
   * Принадлежность к публичным должностным лицам.
   */
  getPublicInfoType(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      prv: false,
      characterPDL: this.getDictType({isReq: true}),
      rodPDL: this.getDictType({isReq: true}),
      fio: this.getFIOType(),
      postRPDL: this.getDictType({isReq: true}),
      postOther: null,
      post: [null, this.validationSrv.getValidation({isReq: true})],
      nameWork: [null, this.validationSrv.getValidation({isReq: true})],
      address: this.getAddressType('req'),
      istDochod: [],
      otherDochod: null

    }, {validators: publicInfoValidator});
  }

  /**
   * Данные миграционной карты
   */
  getMigrationCardInfoType(data?: MigrationCardInfoType): FormGroup {
    return this.formBuilder.group({
      series: [data?.series, this.validationSrv.getValidation({
        max: 50
      })],
      number: [data?.number, this.validationSrv.getValidation({
        max: 50
      })],
      dateStart: [data?.dateStart],
      dateEnd: [data?.dateEnd]
    });
  }

  /**
   * Сведения о документе, подтверждающем право на пребывание (проживание) в РФ
   */
  getResidenceDocInfoType(typePage: DossierAccessEnum, data?: ResidenceDocInfoType): FormGroup {
    //  Обязательность полей по типу вкладки
    const isFieldsReq = ![DossierAccessEnum.SVEDAU,
      DossierAccessEnum.SVEDUDS,
      DossierAccessEnum.SVEDVPR,
      DossierAccessEnum.SVEDBV].includes(typePage);
    if (isFieldsReq){
      return this.formBuilder.group({
        docType: [data?.docType, this.validationSrv.getValidation({
          isReq: true
        })],
        docOther: [data?.docOther, this.validationSrv.getValidation({
          isReq: true,
          max: 250
        })],
        series: [data?.series, this.validationSrv.getValidation({
          max: 50
        })],
        number: [data?.number, this.validationSrv.getValidation({
          max: 50,
          isReq: true
        })],
        dateStart: [data?.dateStart, this.validationSrv.getValidation({
          isReq: true
        })],
        dateEnd: [data?.dateEnd, this.validationSrv.getValidation({
          isReq: true
        })],
        validDoc: [data?.validDoc ?? "1", this.validationSrv.getValidation({
          max: 1
        })],
        organ: [data?.organ, this.validationSrv.getValidation({
          isReq: true
        })],
        kodPodr: [data?.kodPodr, this.validationSrv.getValidation({
          isReq: true,
          max: 7
        })]
      }, {validators: [organResidenceDocInfoValidator]});
    }
    return this.formBuilder.group({
      docType: [data?.docType],
      docOther: [data?.docOther, this.validationSrv.getValidation({
        isReq: true,
        max: 250
      })],
      series: [data?.series, this.validationSrv.getValidation({
        max: 50
      })],
      number: [data?.number, this.validationSrv.getValidation({
        max: 50
      })],
      dateStart: [data?.dateStart],
      dateEnd: [data?.dateEnd],
      validDoc: [data?.validDoc ?? "1", this.validationSrv.getValidation({
        max: 1
      })],
      organ: [data?.organ, this.validationSrv.getValidation({
        isReq: true
      })],
      kodPodr: [data?.kodPodr, this.validationSrv.getValidation({
        isReq: true,
        max: 7
      })]
    }, {validators: [organResidenceDocInfoValidator]});
  }

  /**
   * Реквизиты счета
   */
  getAccountType(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      type: this.getDictType({isReq: true}),
      currency: this.getDictType({isReq: true}),
      accountNumber: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 20
      })],
      dateStart: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      division: [null, this.validationSrv.getValidation({
        max: 50
      })],
      paycards: false,
      paycard: [],
      dateEnd: null,
      row: null,
      $checkedFlk: null,
    });
  }


  /**
   * Полномочия представителя
   */
  getAuthority(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      docName: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 250
      })],
      series: [null, this.validationSrv.getValidation({
        max: 50
      })],
      number: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 50
      })],
      dateReg: [null, this.validationSrv.getValidation({
        isReq: true,
      })],
      dateStart: [null, this.validationSrv.getValidation({
        isReq: true,
      })],
      dateEnd: [null, this.validationSrv.getValidation({
        isReq: true,
      })]
    }, this.validationSrv.getValidation(param));
  }

  /**
   * Копии документов клиента
   */
  getDocumentDossier(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      nameDoc: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 100
      })],
      idDoc: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 250
      })],
      typeDoc: this.getDictType({isReq: true}),
      typeInDoc: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 2000
      })],
      dateInDoc: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      registryId: null
    }, this.validationSrv.getValidation(param));
  }

  /**
   * Сетевая информация о клиенте
   */
  getNetworkInfo(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      ip: [null, this.validationSrv.getValidation({
        max: 39
      })],
      mac: [null, this.validationSrv.getValidation({
        max: 17
      })],
      row: null
    }, this.validationSrv.getValidation(param));
  }

  /**
   * Сведения об обособленных подразделениях
   */
  getDivisionInfo(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      divname: [null, this.validationSrv.getValidation({
        min: 3,
        max: 100
      })],
      divKPP: [null, this.validationSrv.getValidation({
        max: 9
      })],
      divaddress: [null, this.validationSrv.getValidation({
        max: 250
      })],
      row: null
    }, this.validationSrv.getValidation(param));
  }

  /**
   * Состав коллегиального органа управления
   */
  getSostavIOInfo(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      fio: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 250
      })],
      dateFrom: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      dateEnd: null,
      row: null
    }, {
      validator: CustomValidator.dateNotGreaterThan('dateFrom', 'dateEnd', { 'dateCompare': true })
    });
  }


  /**
   * Обновление анкеты клиента
   */
  getUpdateCardInfo(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      dateEditPodFt: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      fio: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 100
      })],
      position: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 60
      })],
      reason: [null, this.validationSrv.getValidation({
	    isReq: true,
        max: 200
      })],
      userId: [null, this.validationSrv.getValidation({
	    isReq: true,
        max: 100
      })],
      row: null
    }, this.validationSrv.getValidation(param));
  }

  /**
   * Сведения об обособленных подразделениях (таблица)
   */
  getDivisions() {
    return null;
  }

  /**
   * Сетевая информация о клиенте (таблица)
   */
  getNetwork() {
    return null;
  }

  /**
   * Обновление анкеты клиента (таблица)
   */
  getUpdateCard() {
    return null;
  }

  /**
   * Дополнительные сведения
   */
  getDopInfo(): FormGroup {
    return this.formBuilder.group({
      divisions: this.getDivisions(),
      selfEmployed: false,
      category: this.getDictType({isReq: true}),
      sho: false,
      goz: false,
      orc: false,
      leastCapital: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      currencyReg: this.getDictType({isReq: true}),
      capital: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      currencyPaid: this.getDictType({isReq: true}),
      share: null,
      asset: [null, this.validationSrv.getValidation({
        max: 2000
      })],
      estate: this.getDictType(),
      otherSource: [null, this.validationSrv.getValidation({
        max: 4000
      })],
      staffCount: [null, this.validationSrv.getValidation({
        max: 5
      })],
      wageFund: null,
      accountsDep: this.getDictType(),
      activity: this.getDictType(),
      income: this.getDictType(),
      reputation: this.getDictType(),
      network: this.getNetwork(),
      dmdk: false,
      dmdkInfo: null,
      nko: false
    }, {validator: dopInfoValidator});
  }

  /**
   * Атрибуты регистрации досье
   */
  getAttributes(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      identificationType: this.getDictType({isReq: true}),
      dateStart: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      dateEnd: null,
      createDate: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      dateNextCheck: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      dateDeath: null,
      fio: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 100
      })],
      position: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 60
      })],
      fioIn: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 100
      })],
      positionIn: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 60
      })],
      updateCard: this.getUpdateCard()
    }, this.validationSrv.getValidation(param));
  }

  /**
   * Оценка уровня риска
   */
  getRiskAssess(param?: ValidatorParamsModel): FormGroup {
    return this.formBuilder.group({
      levelRisk: this.getDictType({isReq: true}),
      serviceRisk: this.getDictType({isReq: true}),
      descriptRisk: [null, this.validationSrv.getValidation({
        max: 4000
      })],
      userId: null,
      fio: null,
      row: null,
      creatDate: null
    }, this.validationSrv.getValidation(param));
  }

  /**
   * Cотрудник, ответственный за работу с клиентом
   */
  getAccessInfo(): FormGroup {
    return this.formBuilder.group({
      id: null,
      user: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      reason: [null, this.validationSrv.getValidation({
        isReq: true,
        max: 250
      })],
      dateFrom: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      dateEnd: [null, this.validationSrv.getValidation({
        isReq: true
      })],
      replacement: false,
      dossierIds: null,
      clientId: null,
      active: null,
      $partId: null
    },{
      validator: CustomValidator.dateNotGreaterThan('dateFrom', 'dateEnd', { 'dateCompare': true })
    });
  }

  getUserInfo() {
    return this.formBuilder.group({
      id: null,
      firstName: null,
      lastName: null,
      middleName: null,
      position: null,
      department: null,
      locked: false,
    });
  }

  protected fbArray(fn, data?, param?, parentValid?) {
    return !data || data.length === 0
      ? this.formBuilder.array([fn.apply(this, [param])], parentValid)
      : this.formBuilder.array(data.map(item => fn.apply(this, [param, item])), parentValid);
  }


}
export function dopInfoValidator(control: AbstractControl): { [key: string]: CustomValidatorError } | null {
  const capital = control.get('capital');
  const leastCapital = control.get('leastCapital');

  if (!capital || !leastCapital) {
    return null;
  }

  capital.setErrors(null);
  if (!checkEmpty(capital) && !checkEmpty(leastCapital)) {
    // Поле capital не может быть меньше поля leastCapital
    if (Number(capital.value) > Number(leastCapital.value)) {
      const error = {
        customValidator: {
          errorMsg: 'Поле заполнено неверно',
          withBigMsg: true,
          withoutSubmitted: true,
          errorMsgBig: 'Поле "Сведения о величине оплаченного уставного (складочного) капитала." ' +
            'не может быть больше поля "Сведения о величине зарегистрированного уставного капитала"'
        } as CustomValidatorError
      };
      capital.setErrors(error);
    }
  }
  function checkEmpty(item) {
    return !(item || {}).value || item.value && item.value === "";
  }
  return null;
}
/**
 * Валидация для orgName
 * должно быть хотя бы одно из полей
 */
export function orgNameTypeValidator(control: AbstractControl): { [key: string]: CustomValidatorError } | null {
  let result = null;
  const orgNameFullRu = control.get('orgNameFullRu');
  const orgNameRu = control.get('orgNameRu');
  const orgNameFullIn = control.get('orgNameFullIn');
  const orgNameIn = control.get('orgNameIn');

  if (!orgNameFullRu || !orgNameRu || !orgNameFullIn || !orgNameIn) {
    return null;
  }

  const validator = [];
  if (checkEmpty(orgNameFullRu) && checkEmpty(orgNameRu) && checkEmpty(orgNameFullIn) && checkEmpty(orgNameIn)) {
    validator.push(Validators.required);
    result = {
      customValidator: {
        errorMsg: 'Необходимо заполнить одно из полей'
      } as CustomValidatorError
    };
  }
  orgNameFullRu.setValidators(validator);
  orgNameFullRu.updateValueAndValidity({onlySelf: true});
  orgNameRu.setValidators(validator);
  orgNameRu.updateValueAndValidity({onlySelf: true});
  orgNameFullIn.setValidators(validator);
  orgNameFullIn.updateValueAndValidity({onlySelf: true});
  orgNameIn.setValidators(validator);
  orgNameIn.updateValueAndValidity({onlySelf: true});
  function checkEmpty(item) {
    return !(item || {}).value || item.value && item.value === "";
  }
  return result;
}

/**
 * Валидация для part
 * Выставляем обязательное поле part по state
 */
export class PartValidator {

  constructor(protected validationSrv: ValidatorService){
  }
  validator(control: AbstractControl): { [key: string]: CustomValidatorError } | null  {
    const state = control.get('state');
    const part = control.get('part');
    const validateParam = {
      max: 6,
      maxNumber: 100,
      minNumber: 0
    } as ValidatorParamsModel;
    if (!state || !part) {
      return null;
    }
    if (state.value && state.value.code === '1') {
      validateParam.isReq = true;
    }
    const validator = this.validationSrv.getValidation(validateParam);
    part.setValidators(validator);
    part.updateValueAndValidity({onlySelf: true});
    return null;
  }
}

/**
 * Валидация для addressType
 * Выставляем обязательное поле region по country
 */
export function addressTypeValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const country = control.get('country');
  const region = control.get('region');
  const validator = [];

  if (!country || !region) {
    return null;
  }
  if (!region.value && country.value && country.value.code === "643") {
    validator.push(Validators.required);
  }
  region.setValidators(validator);
  region.updateValueAndValidity({onlySelf: true});
  return null;
}

/**
 * Валидация для series из DocumentInfo
 * Выставляем обязательное поле series по docType
 */
export function seriesDocumentInfoValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const series = control.get('series');
  const docType = control.get('docType');
  const validator = [];

  if (!series || !docType) {
    return null;
  }
  if ('1' === docType.value?.code) {
    validator.push(Validators.required);
  }
  series.setValidators(validator);
  series.updateValueAndValidity({onlySelf: true});
  return null;
}

/**
 * Валидация для number из DocumentInfo
 * Выставляем обязательное поле number по docType
 */
export function numberDocumentInfoValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const number = control.get('number');
  const docType = control.get('docType');
  const validator = [];

  if (!number || !docType) {
    return null;
  }
  if (!['8', '19', '99'].includes(docType.value?.code)) {
    validator.push(Validators.required);
  }
  number.setValidators(validator);
  number.updateValueAndValidity({onlySelf: true});
  return null;
}

/**
 * Валидация для organ из ResidenceDocInfo
 * Выставляем обязательное поле number по docType
 */
export function organResidenceDocInfoValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const organ = control.get('organ');
  const docType = control.get('docType');
  const validator = [];

  if (!organ || !docType) {
    return null;
  }
  if (!['5', '6'].includes(docType.value?.code)) {
    validator.push(Validators.required);
  }
  organ.setValidators(validator);
  organ.updateValueAndValidity({onlySelf: true});
  return null;
}

/**
 * Валидация для полей из migrationCardInfo
 * Выставляем обязательсть полей по nationality
 */
export function migrationCardInfoValidator(typePage: DossierAccessEnum, control: AbstractControl): { [key: string]: boolean } | null {
    const nationality = control.get('nationality');
    const migrationCardInfo = control.get('migrationCardInfo');
    const isFieldsReq = ![DossierAccessEnum.SVEDAU,
      DossierAccessEnum.SVEDUDS,
      DossierAccessEnum.SVEDVPR,
      DossierAccessEnum.SVEDBV].includes(typePage)&& ['2', '3'].includes(nationality.value?.code);
    migrationCardInfo.get('series')?.setValidators(this.validationSrv.getValidation({
      max: 50,
      isReq: isFieldsReq
    }));
    migrationCardInfo.get('number')?.setValidators(this.validationSrv.getValidation({
      max: 50,
      isReq: isFieldsReq
    }));
    migrationCardInfo.get('dateStart')?.setValidators(this.validationSrv.getValidation({
      isReq: isFieldsReq
    }));
    migrationCardInfo.get('dateEnd')?.setValidators(this.validationSrv.getValidation({
      isReq: isFieldsReq
    }));
    migrationCardInfo.updateValueAndValidity({onlySelf: true});
    return null;
}


/**
 * Валидация для группы полей в publicInfo
 * Выставляем обязательное поля postOther по postRPDL
 * Выставляем обязательное поля otherDochod по istDochod
 *
 */
export function publicInfoValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const postRPDL = control.get('postRPDL');
  const postOther = control.get('postOther');
  const istDochod = control.get('istDochod');
  const otherDochod = control.get('otherDochod');
  if (!postOther || !istDochod || !istDochod) {
    return null;
  }
  if (postRPDL.value && postRPDL.value.code === "99") {
    postOther.setValidators([Validators.required]);
    postOther.updateValueAndValidity({onlySelf: true});
  }
  if (istDochod.value && (istDochod.value as Array<any>).length > 0) {
    const isReqCode = (istDochod.value as Array<any>).find(item => item.code === "8");
    if (isReqCode) {
      otherDochod.setValidators([Validators.required]);
      otherDochod.updateValueAndValidity({onlySelf: true});
    }
  }
  return null;
}
/**
 * Валидация для okved
 * okved или okved2 должны быть для 'ul', 'ip', 'flcp'
 */
export class OkvedValidator {

  public WHITE_LIST_OKVED_CLIENT_TYPE = ['ul', 'ko', 'ip', 'flcp'];
  constructor();
  constructor(typeOrg: TypeOrg, typePage: DossierAccessEnum)
  constructor(private typeOrg?: TypeOrg, private typePage?: DossierAccessEnum){
  }
  validator(control: AbstractControl): { [key: string]: CustomValidatorError } | null  {
    const typeOrgReq = this.WHITE_LIST_OKVED_CLIENT_TYPE.includes(this.typeOrg);
    let result = null;
    const okved = control.get('okved');
    const okved2 = control.get('okved2');

    if (!okved || !okved2) {
      return null;
    }

    const validator = [];
    if (typeOrgReq && getOkvedLen(okved.value) === 0 && getOkvedLen(okved2.value) === 0) {
      if (this.typePage === DossierAccessEnum.SVEDCLIENT) {
        // Валидация для поля оквед и оквед2
        validator.push(Validators.required);
        // Сообщение для группы полей
        result = {
          customValidator: {
            errorMsg: 'Необходимо заполнить одно из полей'
          } as CustomValidatorError
        };
      }
    }
    okved.setValidators(validator);
    okved2.setValidators(validator);
    okved.updateValueAndValidity({onlySelf: true});
    okved2.updateValueAndValidity({onlySelf: true});
    return result;

    function getOkvedLen(list: Array<any>) {
      if (!list) {
        return 0;
      } else {
        return list.length;
      }
    }
  }
}

export type AddressModelType = 'req' | 'real' | 'post';

/**
 * Валидация полей раздела (AML-333)
 * https://doc.comita.lan/pages/viewpage.action?pageId=55813321
 */
export class RegInfoValidator {
  constructor();
  constructor(validationSrv: ValidatorService, isReq: boolean, typePage?: DossierAccessEnum);
  constructor(private validationSrv?: ValidatorService,
              private isReq?: boolean,
              private typePage?: DossierAccessEnum) { }
  validator(control: AbstractControl) {
    const ogrn = control.get('ogrn');
    const dateReg = control.get('dateReg');
    const dateRegIn = control.get('dateRegIn');
    const regNum = control.get('regNum');
    const nameRegOrg = control.get('nameRegOrg');
    if (!ogrn || !dateReg || !dateRegIn || !regNum || !nameRegOrg) {
      return null;
    }

    const nameRegOrgValidator: ValidatorParamsModel = {
      max: 250,
      min: 3
    };
    nameRegOrgValidator.isReq = ogrn.enabled && isValue(ogrn) || regNum.enabled && isValue(regNum); // req(ogrn || regNum)
    nameRegOrg.setValidators(this.validationSrv.getValidation(nameRegOrgValidator));
    nameRegOrg.updateValueAndValidity({onlySelf: true});
    
    if(!this.isReq) {
      if (ogrn.enabled) {
        dateReg.setValidators(isValue(ogrn) ? [Validators.required] : null);
        dateReg.updateValueAndValidity({onlySelf: true});
        const ogrnValidator: ValidatorParamsModel = {
          max: 15,
          isOGRN: true,
          isReq: isValue(dateReg)
        };
        ogrn.setValidators(this.validationSrv.getValidation(ogrnValidator));
        ogrn.updateValueAndValidity({onlySelf: true});
      }
      if (regNum.enabled) {
        dateRegIn.setValidators(isValue(regNum) ? [Validators.required] : null);
        dateRegIn.updateValueAndValidity({onlySelf: true});
        const regNumValidator: ValidatorParamsModel = {
          max: 50,
          isReq: isValue(dateRegIn)
        };
        regNum.setValidators(this.validationSrv.getValidation(regNumValidator));
        regNum.updateValueAndValidity({onlySelf: true});
      }
    }

    function isValue(field: AbstractControl) {
      return !(field.value === null || field.value === "");
    }

  }
}
